@let group = groupSg();
@let isExpanded = isExpandedSg();
@let depth = depthSg();

<div
  class="atn-file-finder-group"
  [class.atn-file-finder-group--nested]="depth > 0"
  [class.atn-file-finder-group--last]="isLastSg()"
>
  <div
    class="atn-file-finder-group__header"
    (click)="isExpandedSg.set(!isExpanded)"
  >
    <i
      class="atn-file-finder-group__toggle-icon atn-icon atn-blue"
      [class.atn-triangle-down]="isExpanded"
      [class.atn-triangle-right]="!isExpanded"
    ></i>
    <span>{{ group.name }}</span>
  </div>

  @if (isExpanded) {
    <div class="atn-file-finder-group__contents">
      @for (child of group.groups; track child.id; let isLast = $last) {
        <atn-file-finder-group
          [depth]="depth + 1"
          [group]="child"
          [isLast]="isLast && !group.files.length"
        />
      }
      @for (file of group.files; track file.id; let isLast = $last) {
        <atn-file-finder-entry
          [entry]="file"
          [isLast]="isLast"
        />
      }
    </div>
  }
</div>
